module.exports = __webpack_public_path__ + "img/7.022891c6.jpg";